<template>
    <!-- Wall-clock mode: pure "HH:MM" string, no date/timezone (e.g. schedule times). -->
    <TimeInput
        v-if="field.wallClock"
        v-model="modelValue"
        :size="props.size"
        :nullable-time="typeof field?.nullable !== 'undefined' ? field.nullable : props.nullable"
        :disabled="props.disabled"
    />
    <Datepicker
        v-else
        v-model="modelValue"
        :tabindex="tabindex"
        :class="[`forms__field_input--${field.type}`]"
        :date="false"
        :time="true"
        :nullable="typeof field?.nullable !== 'undefined' ? field.nullable : props.nullable"
        :required="field.required ? parseInt(field.required) === 1 : props.required"
        :size="props.size"
        :disabled="props.disabled"
    ></Datepicker>
</template>

<script setup lang="ts">
import type { FieldComponent } from '@src/Common/Components/types';

const modelValue = defineModel({
    type: String,
});

const props = withDefaults(defineProps<FieldComponent>(), {});
</script>
